<script lang="ts">
import {
  FIRST_FOOTER_BUTTON_LABEL,
  inspectionPages,
  LAST_FOOTER_BUTTON_LABEL
} from '@/constants/ui/inspection/common/pagesInfo'
import { computed, defineComponent, onMounted, onUpdated, ref } from 'vue'
import CommonButton from '@/components/common/button/CommonButton.vue'
import { ERROR_CODES } from '@/constants/error/errorCode'
import { GlobalError } from '@/utils/globalError/GlobalError'

export default defineComponent({
  name: 'InspectionFooter',
  components: {},
  props: {
    currentPath: { type: String, required: true }
  },
  emit: ['triggerPrevious', 'triggerNext'],
  setup(props, { emit }) {
    /** 前のページへ遷移するボタンの表示ラベル */
    const moveToPreviousPageLabel = ref<string>('')
    /** 次のページへ遷移するボタンの表示ラベル */
    const moveToNextPageLabel = ref<string>('')
    /** 現在のページのインデックス（範囲は調査画面内に限定） */
    const currenPageIndex = computed(() => {
      return inspectionPages.findIndex(
        inspectionPages => inspectionPages.path === props.currentPath
      )
    })

    /**
     * ボタンに表示するラベルを設定する
     * @param なし
     * @returns なし
     */
    const buttonLabelSetting = (): void => {
      if (currenPageIndex.value === -1) {
        throw new GlobalError([ERROR_CODES.COMMON_LABEL_GET_FAILED])
      } else if (currenPageIndex.value === 0) {
        // 最初のページの場合
        moveToPreviousPageLabel.value = FIRST_FOOTER_BUTTON_LABEL
        moveToNextPageLabel.value = inspectionPages[currenPageIndex.value + 1].name
      } else if (currenPageIndex.value === inspectionPages.length - 1) {
        // 最後のページの場合
        moveToPreviousPageLabel.value = inspectionPages[currenPageIndex.value - 1].name
        moveToNextPageLabel.value = LAST_FOOTER_BUTTON_LABEL
      } else {
        moveToPreviousPageLabel.value = inspectionPages[currenPageIndex.value - 1].name
        moveToNextPageLabel.value = inspectionPages[currenPageIndex.value + 1].name
      }
    }

    /**
     * 前ページ遷移のトリガをemitする
     * @param なし
     * @returns なし
     */
    const triggerPrevious = (): void => {
      emit('triggerPrevious')
    }

    /**
     * 次ページ遷移のトリガをemitする
     * @param なし
     * @returns なし
     */
    const triggerNext = (): void => {
      emit('triggerNext')
    }

    onUpdated(() => {
      buttonLabelSetting()
    })

    onMounted(() => {
      buttonLabelSetting()
    })

    // 定義された関数やデータを返却
    return {
      moveToPreviousPageLabel,
      moveToNextPageLabel,
      triggerPrevious,
      triggerNext,
      CommonButton
    }
  }
})
</script>

<template>
  <footer class="footer">
    <div class="footer-content">
      <CommonButton @click="triggerPrevious" class="large-prev-button fw-bold fs-4">
        {{ moveToPreviousPageLabel }}
      </CommonButton>
      <CommonButton @click="triggerNext" class="large-next-button fw-bold fs-4">
        {{ moveToNextPageLabel }}
      </CommonButton>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  color: white;
  text-align: center;
  padding: 20px 0;
  z-index: 10;
  background-color: #d3deff;
  box-shadow: 0 -2px 10px rgba(0, 37, 85, 0.16);
}

.footer-content {
  display: flex;
  justify-content: center;
  gap: 150px;
  padding: 0 20px;
}

.large-prev-button {
  padding: 20px 35px;
  font-size: 1.5rem;
  width: 200px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #ffffff !important;
  color: #2c52cf !important;
  &:hover {
    background-color: #c5c5c5 !important;
  }
}

.large-next-button {
  padding: 20px 35px;
  font-size: 1.5rem;
  width: 200px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #2c52cf !important;
  &:hover {
    background-color: #1c3ba0 !important;
  }
}
</style>
